import {Gender} from '@/models/enums/Gender';

export interface PeselDateObject {
  year: number;
  month: number;
  day: number;
}

/**
 * Parses birth date from Polish PESEL number.
 * PESEL month encoding: 1800s=+80, 1900s=0, 2000s=+20, 2100s=+40, 2200s=+60
 */
export function getBirthDateFromPesel(pesel: string): Date {
  const dateObject = getBirthDateObjectFromPesel(pesel);
  // JavaScript months are 0-indexed
  return new Date(dateObject.year, dateObject.month - 1, dateObject.day);
}

/**
 * Parses birth date object (year, month, day) from Polish PESEL number.
 * PESEL month encoding: 1800s=+80, 1900s=0, 2000s=+20, 2100s=+40, 2200s=+60
 */
export function getBirthDateObjectFromPesel(pesel: string): PeselDateObject {
  if (!pesel || pesel.length < 6) {
    return {year: 0, month: 0, day: 0,};
  }

  const yearPart = parseInt(pesel.substring(0, 2), 10);
  let month = parseInt(pesel.substring(2, 4), 10);
  const day = parseInt(pesel.substring(4, 6), 10);
  let year: number;

  // PESEL month encoding: 1800s=+80, 1900s=0, 2000s=+20, 2100s=+40, 2200s=+60
  if (month > 80) {
    year = 1800 + yearPart;
    month = month - 80;
  } else if (month > 60) {
    year = 2200 + yearPart;
    month = month - 60;
  } else if (month > 40) {
    year = 2100 + yearPart;
    month = month - 40;
  } else if (month > 20) {
    year = 2000 + yearPart;
    month = month - 20;
  } else {
    year = 1900 + yearPart;
  }

  return {year, month, day,};
}

/**
 * Determines gender from Polish PESEL number.
 * The 10th digit (index 9) determines gender: odd = male, even = female.
 */
export function getGenderFromPesel(pesel: string): Gender {
  if (!pesel || pesel.length < 10) {
    return Gender.MALE;
  }
  return parseInt(pesel[9], 10) % 2 === 0 ? Gender.FEMALE : Gender.MALE;
}

const PeselUtils = {
  getBirthDate: getBirthDateFromPesel,
  getBirthDateObject: getBirthDateObjectFromPesel,
  getGender: getGenderFromPesel,
};

export default PeselUtils;
